var map = {
	"./player_-1.png": 23,
	"./player_-1_eliminated.png": 24,
	"./player_0.png": 25,
	"./player_0_eliminated.png": 26,
	"./player_1.png": 27,
	"./player_1_eliminated.png": 28,
	"./player_2.png": 29,
	"./player_2_eliminated.png": 30,
	"./player_3.png": 31,
	"./player_3_eliminated.png": 32,
	"./player_4.png": 33,
	"./player_4_eliminated.png": 34
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5;